<nav class="fab-menu" [class.active]="active">
    <a href="javascript:void(0)" class="fab-toggle" (click)="toggleClick($event)">
        <span > </span> +
    </a>
    <!-- <a #anchor href="javascript:void(0)"  class="fab-item" [matTooltip]="item.descricao | translate" [matTooltipPosition]="'before'" [routerLink]="item.rota">
        <i class="nav-icon material-icons">settings</i>
    </a> -->
    <!-- [routerLink]="item.rota"-->
    <a #anchor href="javascript:void(0)" *ngFor="let item of itens" class="fab-item" [matTooltip]="item.descricao | translate" [matTooltipPosition]="'before'" (click)="acao(item)">
        <i class="nav-icon material-icons">{{item.icone}}</i>
    </a>
</nav>